import VueDisbounce from "./component";

export default VueDisbounce;



// WEBPACK FOOTER //
// ./src/index.js